import React from "react";
import { ModuleConfig } from "../../types/ModuleConfig";

const ModuleUpgradeCockpit = React.lazy(() => import("./ModuleUpgradeCockpit"));

/**
 * Module Upgrade Service cockpit — master-operator tool (never fanned out to
 * tenants). The single surviving surface for module sync since the legacy
 * ModuleSync/ModuleUpgradeMatrix pages were deleted (2026-07-29) and the
 * backend's in-process worker was deleted (2026-08-03, full control-plane/
 * worker-plane separation — backend module `src/modules/module-upgrade/`).
 *
 * Permission gating follows the platform SSOT pattern: `permissionLevel` here
 * is resolved at runtime against the backend manifest
 * (business-builder-backend/src/modules/module-upgrade/permissions.ts) — to
 * change who sees this, edit that file, not this one. Master operators only;
 * plain per-tenant ADMIN is deliberately insufficient (this page fans code
 * across every tenant).
 */
const moduleUpgradeModuleConfig: ModuleConfig = {
    id: "module-upgrade",
    name: "Module Upgrade Service",
    description: "Treehouse-worker module upgrades — drift matrix, queue, live levers, and Doctor runs.",
    version: "0.2.0",
    enabled: true,
    category: "administration",
    order: 96,
    icon: "🌳",

    // ROUTES - permissionLevel is resolved from backend at runtime
    routes: [
        {
            path: "/module-upgrade",
            component: ModuleUpgradeCockpit,
            permissionLevel: "view",
            useLayout: true,
            layoutOptions: { noContainer: true },
        },
    ],

    // NAVIGATION - permissionLevel is resolved from backend at runtime
    navigation: [
        {
            label: "Module Upgrade Service",
            path: "/module-upgrade",
            icon: "🌳",
            permissionLevel: "view",
        },
    ],

    // Empty arrays = backend manifest is the SSOT (resolved via the
    // modulePermissions query, same as every standards-compliant module).
    permissions: { view: [], create: [], edit: [], delete: [] },
};

export default moduleUpgradeModuleConfig;
